export default __webpack_public_path__ + "static/media/food-drinks.d98f0cf3.png";